<template>
  <div class="core_wrap">
    <div class="core_title" v-if="thereTitle.length>0">{{ thereTitle[0] }}</div>
    <div class="braimg">
      <img src="@/assets/img/rectangle.png" alt="" class="hidden-xs-only"/>
    </div>
    <el-row class="core_options" type="flex" justify="space-between">
      <el-col
        class="core_items hidden-xs-only"
        v-for="(item, index) in coresList"
        :key="index"
        :class="item.isActive ? 'is_active' : ''"
        @click.native="changeCurrentIndex(index)"
        >{{ item.tit }}</el-col
      >
      <el-col
        class="core_items2 hidden-sm-and-up"
        v-for="(item, index) in coresList"
        :key="item.tit"
        :class="item.isActive ? 'is_active' : ''"
        @click.native="changeCurrentIndex(index)"
        >{{ item.tit }}</el-col
      >
    </el-row>
    <component :is="currentComponent[currentIndex]"></component>
  </div>
</template>

<script>
import CoreItemOne from './CoreItemOne.vue'
import CoreItemTwo from './CoreItemTwo.vue'
import CoreItemThree from './CoreItemThree.vue'
export default {
  props: {
  thereTitle: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      coresList: [
        {
          tit: '',
          isActive: true,
        },
        {
          tit: '',
          isActive: false,
        },
        {
          tit: '',
          isActive: false,
        },
      ],
      currentIndex: 0,
      currentComponent:[CoreItemOne,CoreItemTwo,CoreItemThree]
    }
  },
  
//   mounted() {  
//         // 获取 URL 中的 code 参数  
//         const urlParams = new URLSearchParams(window.location.search);  
//         const code = urlParams.get('code');  
//         const state = urlParams.get('state'); // 如果需要使用 state 参数  
// console.log(code,state,'1111111111111111111111111111');
//         if (code!=null) {  
//         // 将 code 发送到父页面  
//         window.parent.postMessage({  
//             cmd: 'returnFormJson',  
//             params: {  
//                 QR_code: { code, state }  
//             }  
//         }, '*');  
//       }
//     } ,
  methods: {
    changeCurrentIndex(index) {
      this.currentIndex = index
      this.coresList.map((v, i) => {
        i === index ? (v.isActive = true) : (v.isActive = false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.core_wrap {
  width: 100%;
  margin-top: 10px;
 
  text-align: center;
  .core_title {
    color: #0f0f0f;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 32px;
    line-height: 3.125vw;
    letter-spacing: 5px;
    padding-top: 10px;


    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .braimg{
    display: flex;
    width: 100%;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 10px;
  }
  .core_options {
    width: 0%;
    margin: 0 auto;
    @media screen and (max-width: 0px) {
      width: 0%;
    }
    .core_items {
      width: 0%;
      height: 0px;
    
      font-size: 0px;
      line-height: 0px;
      user-select: none;
      cursor: pointer;
      margin-bottom: 40px;
    }
    .core_items2{
      width: 30%;
      height: 0PX;
      display: flex;
      justify-content: center;
      align-items: center;
     
      padding: 5PX;
      font-size: 0.9rem;
    }
    .is_active {
      color: #fff;
      font-weight: bold;
      background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
      box-shadow: 0 0.5rem 1.5rem 0 rgb(0 135 168 / 50%);
    }
  }
}
</style>